import React from 'react';

const svgProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const icons = {
  admin: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.2" {...stroke} />
      <rect x="14" y="3" width="7" height="7" rx="1.2" {...stroke} />
      <rect x="3" y="14" width="7" height="7" rx="1.2" {...stroke} />
      <rect x="14" y="14" width="7" height="7" rx="1.2" {...stroke} />
    </>
  ),
  cart: (
    <>
      <circle cx="9" cy="20" r="1" {...stroke} />
      <circle cx="19" cy="20" r="1" {...stroke} />
      <path d="M1 1h4l1.7 10.2A2 2 0 0 0 8.7 13h9.6a2 2 0 0 0 2-1.58L21 6H5" {...stroke} />
    </>
  ),
  heart: <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" {...stroke} />,
  package: (
    <>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" {...stroke} />
      <path d="M3.27 6.96 12 12.01 20.73 6.96" {...stroke} />
      <path d="M12 22.08V12" {...stroke} />
    </>
  ),
  shop: (
    <>
      <path d="m2 7 4.3-4.3a1 1 0 0 1 .7-.3h10.4a1 1 0 0 1 .7.3L22 7" {...stroke} />
      <path d="M20 7v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7" {...stroke} />
      <path d="M9 22V12h6v10" {...stroke} />
    </>
  ),
  home: (
    <>
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" {...stroke} />
      <path d="M9 22V12h6v10" {...stroke} />
    </>
  ),
  message: (
    <>
      <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8.5z" {...stroke} />
    </>
  ),
};

/** Minimal line icons for account quick links — jewelry-boutique tone (no emoji). */
export default function AccountTileIcon({ name }) {
  const inner = icons[name];
  if (!inner) return null;
  return (
    <svg {...svgProps} className="account-tile__icon-svg">
      {inner}
    </svg>
  );
}

export function AccountTileChevron() {
  return (
    <svg {...svgProps} className="account-tile__chevron" aria-hidden>
      <path d="m10 17 5-5-5-5" {...stroke} />
    </svg>
  );
}
